import { render } from "./CookiesDialog.vue?vue&type=template&id=cff9179a&scoped=true"
import script from "./CookiesDialog.vue?vue&type=script&lang=js"
export * from "./CookiesDialog.vue?vue&type=script&lang=js"

import "./CookiesDialog.vue?vue&type=style&index=0&id=cff9179a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cff9179a"

export default script